<template>
	<div class="content-wapper">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>在线咨询</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<div class="form-div">
			<el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="right">
				<el-row>
					<el-col :span="15">
						<el-form-item label="企业名称:" prop="entname">
							<span class="entname">{{form.entname}}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="18">
						<el-form-item label="咨询业务:" prop="zxywName">
							<el-radio-group v-model="form.zxywName" v-for="item in zxywNameOptions"
											:key="item.dictValue">
								<el-radio :label="item.dictValue" style="margin-right: 0.625rem;">{{item.dictLabel}}</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="13">
						<el-form-item label="咨询标题:" prop="title">
							<el-input v-model="form.title" placeholder="请输入您要咨询的标题" />
						</el-form-item>
					</el-col>
					<el-col :span="2" style="margin-left: 0.625rem;">
						<el-button type="primary" @click="dialogFun">相似问题</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="咨询内容:" prop="content">
							<el-input type="textarea" :rows="5" placeholder="请输入您要咨询的内容" v-model="form.content" maxlength="300"
								show-word-limit>
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15">
						<el-form-item label="真实名字:" prop="realName">
							<el-input v-model="form.realName" placeholder="请输入您的真实姓名" />
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="联系电话" prop="tel">
							<el-input v-model="form.tel"  placeholder="请输入您的联系电话"/>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="验证码" prop="verificationCode">
							<el-input v-model="form.verificationCode" placeholder="请输入验证码"/>
						</el-form-item>
					</el-col>
					<el-col :span="4" style="text-align: center;">
						<el-button v-show="isViewCode" type="warning" @click="sendOutVerificationCode">发送验证码</el-button>
						<el-button v-show="!isViewCode" type="warning" disabled>剩余时间{{count}}s</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="15" style="margin-top: 1.25rem;">
						<el-form-item>
						    <el-button type="primary" @click="onSubmit">提交</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<el-dialog :title="title" :visible.sync="open" width="60%" append-to-body :close-on-press-escape="close"
		  :close-on-click-modal="close" :destroy-on-close="true">
			<el-table v-loading="loading" :data="list" ref="table" style="width: 100%">
				<el-table-column label="标题" align="center" prop="title" :show-overflow-tooltip="true"/>
				<el-table-column label="内容" align="center" prop="content" :show-overflow-tooltip="true"/>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button size="mini" type="text" @click="toogleExpand(scope.row)">查看</el-button>
					</template>
				</el-table-column>
				<!-- 展开部分 -->
				<el-table-column type="expand" width="1">
					<template slot-scope="scope">
						<el-form label-position="left" inline class="demo-table-expand" style="background-color: #f8f8ff;">
							<div v-for="(item,index) in chatLogs" :key="index" class="for-content">
								<el-row>
									<el-col :span="24" class="chat-time">
										<span style="margin-right: 0.5rem;">■</span>
										<span>{{parseTime(item.replyTime,'{y}-{m}-{d} {h}:{i}:{s}')}}</span>
									</el-col>
								</el-row>
								<el-row>
									<el-col :span="24" class="chat-content">
										<span>{{item.content}}</span>
									</el-col>
								</el-row>
								<el-row class="orgname">
									<el-col :span="24">
										<span>操作人：{{item.replyName}}</span>
									</el-col>
								</el-row>
							</div>
						</el-form>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getList" />
	    </el-dialog>
	</div>
</template>

<script>
	import {addZxzx, sendCode,listZxzx,listReply,findZxzxYw} from "@/api/zxzx/zxzx";
	export default {
		name: 'zxzxForm',
		data() {
			return {
				// 表单参数
				form: {
					entname: undefined,
					zxywName: undefined,
					title: undefined,
					content: undefined,
					realName: undefined,
					tel: undefined,
					verificationCode: undefined,
					ywFwjgRecid:undefined,
				},
				// 表单校验
				rules: {
					zxywName:[
					    { required: true, message: '请选择咨询业务', trigger: 'blur' }
					],
					title:[
					    { required: true, message: '请输入您要咨询的标题', trigger: 'blur' }
					],
					content:[
					    { required: true, message: '请输入您要咨询的内容', trigger: 'blur' }
					],
					realName:[
					    { required: true, message: '请输入真实姓名', trigger: 'blur' }
					],
					tel:[
					    { required: true, message: '请输入手机号', trigger: 'blur' }
					],
				},
				verificationCode:undefined,
				zxywNameOptions:[],
				isViewCode: true,
				count: '',
				timer: null,
				// 弹出层标题
				title: "",
				// 是否显示弹出层
				open: false,
				close: false,
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					title:undefined
				},
				chatLogs:[],
				ywFwjgRecid: undefined
			}
		},
		created() {
			this.getDict();
			this.getlocalStorage();
			setTimeout(function() {
				localStorage.removeItem("zxzx_zxywName");
			}, 5000);
			let ssessionLogin = JSON.parse(localStorage.getItem('ssessionLoginUser'));
			//----【】需要修改为recid
			this.ywFwjgRecid = ssessionLogin.user.ywFwjgRecid;
			this.form.entname=ssessionLogin.user.corname;
			this.form.ywFwjgRecid=ssessionLogin.user.ywFwjgRecid;
		},
		methods:{
			getDict(){
				// this.getDicts("yw_zxzx_ywlx").then(response => {
				// 	this.zxywNameOptions = response.data;
				// });
				findZxzxYw().then(response =>{
					this.zxywNameOptions = response.data;
				});
			},
			getlocalStorage(){
				const en = JSON.parse(localStorage.getItem('zxzx_zxywName'));
				if (en != undefined && en != "") {
					this.form.zxywName = en;
				}
			},
			clearlocalStorage(){
				localStorage.removeItem("zxzx_zxywName");
			},
			onSubmit(){
				if (this.utils.isLoginTimeout()) {
					this.$refs["form"].validate(valid => {
						if(valid){
							if (this.verificationCode==this.form.verificationCode){
								addZxzx(this.form).then(response => {
									if (response.code === 200) {
										this.msgSuccess("新增成功");
										this.form.zxywName = undefined;
										this.form.title = undefined;
										this.form.content = undefined;
										this.form.realName = undefined;
										this.form.tel = undefined;
										this.form.verificationCode = undefined;
										this.isViewCode= true;
										this.count= '';
									} else {
										this.msgError(response.msg);
									}
								});
							}else {
								this.msgError("验证码输入错误！");
							}
						}
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
			},
			sendOutVerificationCode(){
				if(this.form.tel != null){
					const tel = this.form.tel;
					sendCode(tel).then(response => {
						this.verificationCode = response.data;
					});
					const TIME_COUNT = 120;
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.isViewCode = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.isViewCode = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000)
					}
				}else {
					this.msgError("请先输入手机号！");
				}
			},
			dialogFun(){
				this.open = true;
				this.queryParams.title = this.form.title;
				this.getList();
			},
			getList() {
				this.loading = true;
				listZxzx(this.queryParams).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			// 查看  展开行效果 
			toogleExpand(row) {
				// console.log("row==",row);
				listReply({zxzxRecid:row.recid}).then(response => {
					this.chatLogs = response.rows;
				});
				const $table = this.$refs.table
				// 注意，这里的 this.list 是上面 data 中的 list
				// 通过比对数据与行里的数据，对展开行进行控制，获取对应值
				this.list.map((item) => {
					if (row.recid !== item.recid) {
						$table.toggleRowExpansion(item, false)
					}
				})
				$table.toggleRowExpansion(row)
			},
		}
	}
</script>

<style scoped="scoped">
	
	.app-container {
		padding: 0px 15px 20px;
	}

	.navigation {
		padding: 20px;
		line-height: 20px;
		height: 60px;
		background-color: #f1f1f1;
	}

	.form-div {
		border: 0.0625rem solid #ebebeb;
		border-radius: 0.1875rem;
		transition: .2s;
		padding-top: 1.875rem;
		margin-top: 0.625rem;
		text-align: left !important; 
		margin-bottom: 3rem;
	}

	.entname {
		float: left;
	}
	
	/deep/ .el-radio-button__inner, .el-radio-group{
		display: inline-block;
		vertical-align: middle;
		line-height: 2.25rem;
	}
	.for-content{
		padding: 0.625rem;
	}
	.chat-time{
		line-height: 1.25rem;
		padding: 0.625rem 1.25rem;
		text-align: left;
	}
	.chat-content{
		line-height: 1.25rem;
		padding: 0.625rem 0 0 3rem;
		text-align: left;
		color: #7574aa;
	}
	.orgname{
		margin-top: 1rem;
		text-align: right;
		padding: 0 1rem 1rem 0;
	}
	.reply{
		color: #409EFF;
		cursor: pointer;
	}
	.chat-col{
		text-align: left;
		padding: 0.625rem;
	}
</style>
